module.exports = __webpack_public_path__ + "static/img/GU@3x.f35d3472.png";